import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { map } from "rxjs/operator/map";

@Injectable()
export class ConnectService {
    constructor(
        private http: Http
    ){}

    isOperating() {
        return this.http.get('values');
    }
}


// WEBPACK FOOTER //
// ./src/app/login/shared/connect.service.ts